const GIS_SRC = 'https://accounts.google.com/gsi/client';

let loader = null;

export const googleClientId = () => process.env.VUE_APP_GOOGLE_CLIENT_ID;

const identityApi = () => (window.google && window.google.accounts && window.google.accounts.id);

// Resolves with `google.accounts.id`. The script tag is injected on demand so the login page is the
// only place that ever reaches out to Google.
export const loadGoogleIdentity = () => {
  const loaded = identityApi();
  if (loaded) return Promise.resolve(loaded);

  if (!loader) {
    loader = new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.src = GIS_SRC;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve(identityApi());
      script.onerror = () => {
        loader = null;
        reject(new Error('Failed to load Google Identity Services'));
      };

      document.head.appendChild(script);
    });
  }

  return loader;
};

export default {
  googleClientId,
  loadGoogleIdentity,
};
